import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Area from '@components/common/Area';
import LoadingBar from '@components/common/LoadingBar';
import { NavProvider, useNav } from '@components/common/context/NavContext';
import './Layout.scss';
import './tailwind.scss';
import { useLanguage } from '@components/common/locale/useLanguage';
import { StoreStatusProvider } from '@components/common/context/StoreStatusContext';
function Header(_ref) {
  var {
    isAutoHideActive
  } = _ref;
  var {
    isAr
  } = useLanguage();
  var {
    setHeaderVisible,
    setHeaderHeight
  } = useNav();
  var [showHeader, setShowHeader] = useState(true);
  var headerRef = useRef(null);
  useEffect(() => {
    if (!isAutoHideActive) {
      setShowHeader(true);
      return undefined;
    }
    var lastScrollY = window.scrollY;
    var handleScroll = () => {
      var currentScrollY = window.scrollY;
      if (currentScrollY < 50) {
        setShowHeader(true);
      } else if (currentScrollY > lastScrollY) {
        setShowHeader(false); // scrolling down
      } else {
        setShowHeader(true); // scrolling up
      }
      lastScrollY = currentScrollY;
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isAutoHideActive]);
  useEffect(() => {
    setHeaderVisible(showHeader);
  }, [showHeader, setHeaderVisible]);
  useEffect(() => {
    var el = headerRef.current;
    if (!el) return undefined;
    var updateHeight = () => setHeaderHeight(el.offsetHeight);
    updateHeight();
    var resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(el);
    window.addEventListener('resize', updateHeight);
    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', updateHeight);
    };
  }, [setHeaderHeight]);
  return /*#__PURE__*/React.createElement(StoreStatusProvider, null, /*#__PURE__*/React.createElement("div", {
    ref: headerRef,
    className: "header header-wrapper ".concat(showHeader ? 'header-show' : 'header-hide', " bg-primary z-[120]")
  }, /*#__PURE__*/React.createElement("div", {
    className: "relative grid grid-cols-3 mx-auto max-w-[112rem]"
  }, /*#__PURE__*/React.createElement(Area, {
    id: "header",
    noOuter: true,
    coreComponents: [{
      component: {
        default: Area
      },
      props: {
        id: 'icon-wrapper',
        className: "icon-wrapper bg-primary flex  space-x-4 gap-6 ".concat(isAr ? 'flex-row-reverse justify-start ' : ' flex justify-end')
      },
      sortOrder: 20
    }]
  }))));
}
Header.propTypes = {
  isAutoHideActive: PropTypes.bool.isRequired
};
export default function Layout() {
  var [isAutoHideActive, setIsAutoHideActive] = useState(false);
  var [isAccountPage, setIsAccountPage] = useState(false);
  useEffect(() => {
    var evaluate = () => {
      var isHomepage = window.location.pathname === '/';
      var isAccountPage = window.location.pathname === '/account';
      var isMobile = window.innerWidth < 768;
      setIsAutoHideActive(isHomepage && isMobile);
      setIsAccountPage(isAccountPage && isMobile);
    };
    evaluate();
    window.addEventListener('resize', evaluate);
    return () => window.removeEventListener('resize', evaluate);
  }, []);
  var contentStyle = isAutoHideActive ? {
    marginTop: '125px'
  } : undefined;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LoadingBar, null), /*#__PURE__*/React.createElement(NavProvider, null, /*#__PURE__*/React.createElement(Header, {
    isAutoHideActive: isAutoHideActive
  }), /*#__PURE__*/React.createElement("main", {
    className: "content ".concat(isAccountPage && 'mt-[12rem]'),
    style: contentStyle
  }, /*#__PURE__*/React.createElement(Area, {
    id: "content",
    noOuter: true
  })), /*#__PURE__*/React.createElement("div", {
    className: " bg-primary"
  }, /*#__PURE__*/React.createElement(Area, {
    id: "footer",
    noOuter: true,
    coreComponents: []
  }))));
}
;